// import ReactDom from 'react-dom/server'
import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { BsInstagram, BsTiktok } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { TfiWorld } from "react-icons/tfi";
import { dbAdmin } from "../../lib/firebase-admin";
import algoliasearch from "algoliasearch/lite";
import { renderToString } from "react-dom/server";

import {
  InstantSearch,
  Configure,
  useInstantSearch,
  useHits,
  useCurrentRefinements,
  InstantSearchSSRProvider,
} from "react-instantsearch-hooks-web";
import PropertyTownHit from "../../components/search/PlacePropertyHit/PropertyTownHit";

import { getServerState } from "react-instantsearch-hooks-server";
import dynamic from "next/dynamic";
const TownsRefinementList = dynamic(() =>
  import("../../components/filters/TownRefinements")
);
const BedBathRefinement = dynamic(() =>
  import("../../components/filters/BedBathRefinement")
);
const ListingTypeRefinementList = dynamic(() =>
  import("../../components/filters/ListingTypeRefinement")
);
const PropertyTypeRefinement = dynamic(() =>
  import("../../components/filters/PropertyTypeRefinement")
);
const PriceRangeRefinement = dynamic(() =>
  import("../../components/filters/PriceRangeRefinement")
);
const CurrentRefinements = dynamic(() =>
  import("../../components/filters/CurrentRefinements")
);
const MobileFilterModal = dynamic(() =>
  import("../../components/filters/mobile/MobileFilterModal")
);

import { TiSocialFacebook } from "react-icons/ti";
import { getUrl } from "../../utils/getUrl";
// import Link from "next/link";
import { titleCase } from "../../utils/transform/sentenceCase";
import moment from "moment";
import { capture } from "../../utils/analytics/capture";

const algoliaClient = algoliasearch(
  process.env.NEXT_PUBLIC_SEARCH_APP_ID,
  process.env.NEXT_PUBLIC_SEARCH_API_KEY
);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      // return Promise.resolve({
      //   results: requests.map(() => ({
      //     hits: [],
      //     nbHits: 0,
      //     nbPages: 0,
      //     page: 0,
      //     processingTimeMS: 0,
      //     hitsPerPage: 150,
      //     exhaustiveNbHits: false,
      //     query: "",
      //     params: "",
      //   })),
      // });
    }
    return algoliaClient.search(requests);
  },
};

function AllEmptyQueryBoundary({ children, fallback, town }) {
  const { indexUiState, results, status } = useInstantSearch();
  const { items, canRefine, refine } = useCurrentRefinements();

  if (!results.__isArtificial && results.nbHits === 0) {
    return (
      <>
        <div className=" flex min-h-[80vh] flex-row divide-x divide-gray-200 lg:px-40 ">
          <div className="  w-full bg-white lg:bg-white">
            <div className=" my-1 px-5 pb-1 lg:mb-3 lg:mt-6 lg:px-8 lg:py-0">
              {/* <span className=" text-xl font-semibold lg:text-2xl">
                Homes by {town.listerName}
              </span> */}
            </div>

            {items.length > 0 ? (
              <div className="flex min-h-[60vh] flex-col items-center gap-y-2 overscroll-y-auto px-5 pt-20 lg:gap-y-2 lg:px-8 ">
                <span className=" text-center text-xl font-semibold text-gray-800">
                  No homes by {town.listerInfo.listerName} matching that filter
                  found
                </span>
                <span className=" text-gray-800">
                  Check back soon or adjust filter
                </span>
              </div>
            ) : (
              <div className="flex min-h-[60vh] flex-col items-center gap-y-2 overscroll-y-auto px-5 pt-32 lg:gap-y-2 lg:px-8 ">
                <span className=" flex flex-row space-x-1 text-xl ">
                  <span>No homes listed by </span>
                  <span className=" font-semibold text-gray-800">
                    {town.listerInfo.listerName}
                  </span>
                  <span></span>
                </span>
                <span className=" text-gray-700">Check back soon</span>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
  return <>{children}</>;
}

function CustomPropertyTown({
  town,
  loadingProperty,
  setLoadingProperty,
  selectedProperty,
  selectedPropertyId,
}) {
  const { hits, results, sendEvent } = useHits();
  // console.log(town);
  return (
    <>
      {results.nbHits > 0 ? (
        <div className=" flex min-h-[80vh] flex-row divide-x divide-gray-200 lg:px-20 ">
          <div className="  bg-gray-50 w-full lg:bg-white">
            <div className=" my-1 px-5 pb-1 lg:mb-6 lg:mt-1 lg:px-8 lg:py-0">
              <h2 className=" hidden text-xl font-semibold lg:text-2xl">
                {town.listerInfo.listerName} Properties
              </h2>
            </div>

            <div className=" grid min-h-[70vh] grid-cols-1 gap-y-8 overscroll-y-auto px-5 pb-10 md:grid-cols-2 md:gap-10 lg:grid-cols-3 lg:gap-8 lg:px-8 ">
              {hits.map((town) => {
                return (
                  <PropertyTownHit
                    sendEvent={sendEvent}
                    key={town.objectID}
                    hit={town}
                    loadingProperty={loadingProperty}
                    setLoadingProperty={setLoadingProperty}
                    reff={(el) =>
                      (selectedProperty.current[town.objectID] = el)
                    }
                    selectedPropertyId={selectedPropertyId}
                  />
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

function Lister({ serverState, listerData, count }) {
  let lister = JSON.parse(listerData);
  let serv = serverState;
  // console.log(serv?.initialResults?.staging_PROPERTIES.results[0].hits.length);
  const [listingType, setListingType] = useState("Rent");
  const [propertyType, setPropertyType] = useState("Apartment");
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  const [selectedTowns, setSelectedTowns] = useState([]);
  const [minMaxRent, setMinMaxRent] = useState({
    min: undefined,
    max: undefined,
  });
  const [currentRefinements, setCurrentRefinements] = useState([]);
  const router = useRouter();
  const [loadingResults, setLoadingResults] = useState(false);

  const [loadingProperty, setLoadingProperty] = useState(null);

  useEffect(() => {
    if (router != null) {
      capture({
        category: "browse",
        event: "page_view",
        properties: {
          page_type: "lister",
          townID: lister.listerInfo.listerTown?.townID,
          listerTown: lister.listerInfo.listerTown?.townName,
          countyID: lister.listerInfo.listerCounty?.countyID,
          countyName: lister.listerInfo.listerCounty?.countyName,
          listerID: lister.listerID,
          listerName: lister.listerInfo.listerName,
        },
      });
    }
  }, []);

  function LoadingIndicator() {
    const { status } = useInstantSearch();
    if (status === "stalled" || status === "stalled") {
      return <p className="mx-40 text-gray-600">Loading search results</p>;
    }
    return null;
  }

  const [openMobileModal, setOpenMobileModal] = useState(false);

  const ogURL = `${getUrl()}/api/lister-og?username=${
    lister.listerInfo.listerUserName
  }&description=&name=${lister.listerInfo.listerName}&phone=0${
    lister.listerInfo.listerPhone
  }&area=${JSON.stringify(lister.listerInfo.listerArea)}&town=${JSON.stringify(
    lister.listerInfo.listerTown
  )}&county=${JSON.stringify(lister.listerInfo.listerCounty)}`;

  const props =
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? serverState?.initialResults?.properties?.results[0]?.hits
      : serverState?.initialResults?.staging_PROPERTIES?.results[0]?.hits;
  let listingsSchemas = props?.map((property) => {
    return {
      "@type": "RealEstateListing",
      "@id": `${getUrl()}/homes/${property.slugShort}`,
      name: property?.propertyName ?? "",
      description: titleCase(property?.propertyDescription?.substring(0, 160)),
      image: Object.entries(property.images).map((image) => {
        return image[1].url;
      }),
      url: `${getUrl()}/homes/${property.slugShort}`,
      datePosted: moment(property?.inputData?.addedTime?.time).format(
        "YYYY-MM-DD"
      ),
      offers: {
        "@type": "Offer",
        priceCurrency: "KES",
        price:
          property?.listingType === "RENT"
            ? property?.monthlyRent
            : property?.price,
        availability: "http://schema.org/InStock",
        validFrom: moment(property?.inputData?.addedTime?.time).format(
          "YYYY-MM-DD"
        ),
        category: property?.listingType === "RENT" ? "For Rent" : "For Sale",
        // leaseLength: 6,
      },
    };
  });

  const schemaData = {
    "@context": "http://schema.org",
    "@type": "RealEstateAgent",
    "@id": `${getUrl()}/${lister.listerInfo.listerUserName}`,
    name: lister.listerInfo.listerName,
    telephone: "+254" + lister.listerInfo.listerPhone,
    email: lister.auth.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: lister.listerInfo.listerTown.townName,
      addressLocality: lister.listerInfo.listerCounty.countyName,
      addressRegion: "KE",
      // postalCode: "62701",
    },
    image:
      lister.auth.photo && lister.auth.photo != "https://default"
        ? lister.auth.photo
        : ogURL,
    url: `${getUrl()}/${lister.listerInfo.listerUserName}`,
    memberOf: {
      "@type": "Organization",
      name: lister.listerInfo.listerName,
    },
    owns: listingsSchemas,
  };

  const breadSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "Webpage",
          "@id": `${getUrl()}`,
          name: "Zote",
          url: `${getUrl()}`,
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "WebPage",
          "@id": `${getUrl()}/agent/${lister.listerInfo.listerUserName}`,
          name: `${lister.listerInfo.listerName}`,
          url: `${getUrl()}/agent/${lister.listerInfo.listerUserName}`,
          image: `${ogURL}`,
        },
      },
    ],
  };
  const selectedProperty = useRef({});
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  let updatedMonth = moment().format("MMM");
  let updatedYear = moment().format("YYYY");
  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <title>
          Houses listed by{" "}
          {`${lister.listerInfo.listerName} | ${updatedYear} - Zote App`}
        </title>
        <meta
          property="og:title"
          content={`Houses listed by
          ${lister.listerInfo.listerName} | ${updatedYear} - Zote App`}
        />
        <meta
          name="description"
          content={`${lister.listerInfo.listerName} specializes in houses and real estate in ${lister.listerInfo.listerTown.townName}, the greater part of ${lister.listerInfo.listerCounty.countyName} and more towns in Nairobi. View properties... | Zote`}
        />

        <meta
          property="og:description"
          content={`${lister.listerInfo.listerName} specializes in houses and real estate in ${lister.listerInfo.listerTown.townName}, the greater part of ${lister.listerInfo.listerCounty.countyName} and more towns in Nairobi. View properties... | Zote`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`${getUrl()}/agent/${lister.listerInfo.listerUserName}`}
        />
        <meta property="og:image" content={`${ogURL}`} />

        <link
          rel="canonical"
          href={`${getUrl()}/agent/${lister.listerInfo.listerUserName}`}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadSchema) }}
        />
      </Head>
      <main
        // ref={targetElement}
        className=" relative flex flex-col space-y-4  "
      >
        <div className="  flex flex-col space-y-4 px-6 pt-5 lg:h-64 lg:flex-row lg:items-center lg:justify-center lg:space-x-8 lg:space-y-0 lg:px-24 lg:pt-5">
          {lister.auth.photo && lister.auth.photo != "https://default" ? (
            <div className=" bg-zote-primary-100 relative flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-full border border-gray-300 shadow lg:h-32 lg:w-32">
              <Image
                src={lister.auth.photo}
                alt={lister.listerInfo.listerName}
                className=" h-full w-full rounded-full object-cover"
                priority
                layout="fill"
              />
            </div>
          ) : (
            <div className=" flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 lg:h-32 lg:w-32">
              <CgProfile className=" h-8 w-8  text-zote-secondary lg:h-12 lg:w-12" />
            </div>
          )}
          <div className=" flex flex-col space-y-0 pl-1 lg:pl-0">
            <h1 className=" cursor-default text-2xl font-bold lg:text-4xl">
              {lister.listerInfo.listerName}
            </h1>
            {/* <Link href={`/town/${lister.listerInfo.listerTown.townSlug}`}>
              <a className=" hidden">
                <h2>
                  {"Find close Real Estate Agent" +
                    " in " +
                    lister.listerInfo.listerTown.townName +
                    ", " +
                    lister.listerInfo.listerCounty.countyName}{" "}
                  County
                </h2>
              </a>
            </Link> */}
            {/* <div className=" flex flex-col">
              <a
                onClick={() => {
                 
                 
                }}
                href={`tel:+254${lister.listerInfo.listerPhone}`}
                className=" cursor-pointer text-sm text-gray-600"
              >
                0{lister.listerInfo.listerPhone}
              </a>
            </div> */}
            <div className=" flex flex-col space-y-1 pt-1">
              {Object.keys(lister.listerSocial).length != 0 ? (
                <span className=" text-xs uppercase text-gray-600">
                  On the web
                </span>
              ) : null}
              <div className=" flex flex-row space-x-2">
                {Object.keys(lister.listerSocial).length != 0 ? (
                  <h2 className=" hidden text-xs uppercase text-gray-600">
                    On the web
                  </h2>
                ) : null}
                {lister.listerSocial?.website?.name ? (
                  <>
                    <h3 className=" hidden">Website</h3>

                    <a
                      target="_blank"
                      href={`https://` + lister.listerSocial.website.name}
                      rel="noreferrer"
                    >
                      <div className=" flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200">
                        <TfiWorld className="h-4 w-4" />
                      </div>
                    </a>
                  </>
                ) : null}
                {lister.listerSocial?.facebook_page?.name ? (
                  <>
                    <h3 className=" hidden">Facebook</h3>
                    <a
                      target="_blank"
                      rel="nofollow noreferrer"
                      href={
                        `https://facebook.com/@` +
                        lister.listerSocial.facebook_page?.name
                      }
                    >
                      <div className=" flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200">
                        <TiSocialFacebook className="h-6 w-6 " />
                      </div>
                    </a>
                  </>
                ) : null}
                {lister.listerSocial?.tiktok?.name ? (
                  <>
                    <h3 className=" hidden">Tiktok</h3>
                    <a
                      target="_blank"
                      rel="nofollow noreferrer"
                      href={
                        `https://tiktok.com/@` + lister.listerSocial.tiktok.name
                      }
                    >
                      <div className=" flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200">
                        <BsTiktok className="h-4 w-4 " />
                      </div>
                    </a>
                  </>
                ) : null}
                {lister.listerSocial?.instagram?.name ? (
                  <>
                    <h3 className=" hidden">Instagram</h3>
                    <a
                      target="_blank"
                      rel="nofollow noreferrer"
                      href={
                        `https://instagram.com/` +
                        lister.listerSocial.instagram.name
                      }
                    >
                      <div className=" flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200">
                        <BsInstagram className="h-4 w-4 " />
                      </div>
                    </a>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <InstantSearchSSRProvider {...serverState}>
          <InstantSearch
            searchClient={searchClient}
            indexName={process.env.NEXT_PUBLIC_PROPERTIES_INDEX}
            // routing={{
            //   router: history({
            //     getLocation: () =>
            //       typeof window === "undefined"
            //         ? "https://ula.africa/"
            //         : window.location,
            //   }),
            // }}
            // initialUiState={serverState}
          >
            <MobileFilterModal
              open={openMobileModal}
              setOpen={setOpenMobileModal}
              listingType={listingType}
              setListingType={setListingType}
            />

            <>
              {count > 0 ? (
                <>
                  <div className="hidden h-auto w-full flex-row items-center space-x-4  space-y-3 px-6 lg:flex lg:h-16 lg:space-y-0  lg:px-40 ">
                    <ListingTypeRefinementList
                      listingType={listingType}
                      setListingType={setListingType}
                    />
                    <PropertyTypeRefinement />
                    <PriceRangeRefinement listingType={listingType} />
                    <BedBathRefinement />
                    <TownsRefinementList />
                  </div>
                  <div className=" flex flex-row space-x-3 pl-5 lg:hidden">
                    <button
                      onClick={() => {
                        setOpenMobileModal(!openMobileModal);
                      }}
                      className="flex-shrink-0 cursor-pointer select-none rounded border border-blue-600 bg-white px-5 py-2 text-sm capitalize text-blue-600"
                    >
                      Filters
                    </button>
                  </div>
                </>
              ) : null}
              <Configure
                hitsPerPage={150}
                maxValuesPerFacet={100}
                filters={`listerID:"${lister.listerID}"`}
              />
            </>

            {/* <LoadingIndicator /> */}
            <div className="flex min-h-[50vh]  flex-col px-0 pb-5 pt-0 lg:px-10 lg:pt-0">
              <CurrentRefinements source="LISTER" />
              <AllEmptyQueryBoundary fallback={null} town={lister}>
                <CustomPropertyTown
                  town={lister}
                  loadingProperty={loadingProperty}
                  setLoadingProperty={setLoadingProperty}
                  selectedProperty={selectedProperty}
                  selectedPropertyId={selectedPropertyId}
                />
              </AllEmptyQueryBoundary>
            </div>
          </InstantSearch>
        </InstantSearchSSRProvider>
      </main>
    </>
  );
}

export async function getStaticProps({ params }) {
  const listerName = params.lister;
  if (!params) {
    return { notFound: true };
  }
  const listerRef = dbAdmin
    .collection("Listers")
    .where("onboardingComplete", "==", true)
    .where("listerVerified", "==", true)
    .where("listerInfo.listerUserName", "==", listerName)
    .where("listerInfo.listerType", "!=", "INDIVIDUAL_OWNER")
    .limit(1);
  const querySnapshot = await listerRef.get();
  // if (
  //   querySnapshot.docs[0].data().listerInfo.listerType === "INDIVIDUAL_OWNER"
  // ) {
  //   return;
  // }
  let listerData = [];
  if (querySnapshot.empty) {
    return {
      notFound: true,
    };
  }
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    const listerID = doc.id;
    // if (data.listerInfo.listerUserName !== "INDIVIDUAL_OWNER") {
    listerData.push(
      Object.assign(
        {
          listerID,
        },
        data
      )
    );
    //  }
  });

  const propertiesRef = dbAdmin
    .collection("Listers")
    .doc(listerData[0].listerID)
    .collection("ListerProperties");
  const snapshot = await propertiesRef
    .where("status", "==", "ACTIVE")
    .count()
    .get();
  const count = snapshot.data().count;
  const serverState = await getServerState(
    <Lister listerData={JSON.stringify(listerData[0])} count={count} />,
    { renderToString }
  );

  return {
    props: {
      listerData: JSON.stringify(listerData[0]),
      count,
      serverState,
    },
    revalidate: 900,
  };
}

export async function getStaticPaths() {
  const citiesRef = dbAdmin
    .collection("Listers")
    .where("onboardingComplete", "==", true)
    .where("listerVerified", "==", true)
    .where("listerInfo.listerType", "!=", "INDIVIDUAL_OWNER");
  const querySnapshot = await citiesRef.get();
  let posts = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    const postID = doc.id;
    posts.push(
      Object.assign(
        {
          postID,
        },
        data
      )
    );
  });

  // Get the paths we want to pre-render based on posts
  const paths = posts.map((post) => ({
    params: { lister: post.listerInfo.listerUserName },
  }));

  const filteredPaths = paths.filter((p) => p !== "/404" && p !== "/500");

  // We'll pre-render only these paths at build time.
  // { fallback: blocking } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths: filteredPaths, fallback: "blocking" };
}

export default Lister;
